/* --- inline script #0 --- */

/* Cortisol-cycle tilt response.
   - On phones, reads DeviceOrientationEvent (gamma=L/R tilt, beta=front/back) and
     applies a subtle 3D rotateX/rotateY to the cycle graphic.
   - On iOS 13+ the spec requires explicit permission via a user gesture, so we
     surface a small "Enable tilt" pill in that case.
   - On desktop, falls back to mouse-move parallax over the cycle card.
   - Respects prefers-reduced-motion. */
(function () {
  const stage = document.querySelector('.cycle-orbit');
  if (!stage) return;
  const wrap = stage.querySelector('.cycle-tilt-wrap');
  const prompt = stage.querySelector('.cycle-tilt-prompt');
  if (!wrap) return;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const MAX_X = 9;   // rotateY cap (left-right tilt)
  const MAX_Y = 7;   // rotateX cap (front-back tilt)
  const SMOOTH = 0.08;

  let target = { rx: 0, ry: 0 };
  let current = { rx: 0, ry: 0 };
  let rafId = null;

  function loop() {
    current.rx += (target.rx - current.rx) * SMOOTH;
    current.ry += (target.ry - current.ry) * SMOOTH;
    wrap.style.transform = 'perspective(900px) rotateX(' + current.rx.toFixed(2) + 'deg) rotateY(' + current.ry.toFixed(2) + 'deg)';
    rafId = requestAnimationFrame(loop);
  }
  function startLoop() {
    if (!rafId) {
      wrap.classList.add('active');
      loop();
    }
  }

  let baseBeta = null;
  function onOrientation(e) {
    if (e.gamma == null && e.beta == null) return;
    const g = e.gamma || 0;            // -90..90  left/right
    const b = e.beta || 0;             // -180..180 front/back
    // Anchor beta to the device's resting angle (first reading)
    if (baseBeta == null) baseBeta = b;
    const dB = b - baseBeta;
    target.ry = Math.max(-MAX_X, Math.min(MAX_X, g * 0.20));
    target.rx = Math.max(-MAX_Y, Math.min(MAX_Y, -dB * 0.18));
    startLoop();
  }

  function onMouse(e) {
    const r = stage.getBoundingClientRect();
    const cx = r.left + r.width / 2;
    const cy = r.top + r.height / 2;
    const dx = (e.clientX - cx) / (r.width / 2);
    const dy = (e.clientY - cy) / (r.height / 2);
    target.ry = Math.max(-MAX_X, Math.min(MAX_X, dx * MAX_X));
    target.rx = Math.max(-MAX_Y, Math.min(MAX_Y, -dy * MAX_Y));
    startLoop();
  }
  function onMouseLeave() {
    target.rx = 0; target.ry = 0;
  }

  const hasOrient = typeof window.DeviceOrientationEvent !== 'undefined';
  const isTouch = 'ontouchstart' in window || (navigator.maxTouchPoints || 0) > 0;
  const needsPermission = hasOrient && typeof DeviceOrientationEvent.requestPermission === 'function';

  function attachOrientation() {
    window.addEventListener('deviceorientation', onOrientation, { passive: true });
  }

  if (hasOrient && isTouch && !needsPermission) {
    // Android & older iOS: just listen
    attachOrientation();
  } else if (hasOrient && isTouch && needsPermission && prompt) {
    // iOS 13+: surface a permission affordance
    prompt.hidden = false;
    prompt.addEventListener('click', async function () {
      try {
        const state = await DeviceOrientationEvent.requestPermission();
        if (state === 'granted') {
          prompt.hidden = true;
          attachOrientation();
        }
      } catch (_) { /* user denied or unsupported — quietly drop */ }
    });
  } else {
    // Desktop / no sensors: mouse parallax over the card
    stage.addEventListener('mousemove', onMouse);
    stage.addEventListener('mouseleave', onMouseLeave);
  }
})();
